import type { InjectionKey } from "vue";
import { inject, provide } from "vue";

export const useCtx = <T>() => {
  const key = Symbol() as InjectionKey<T>;

  return {
    key,
    provide: (value: T) => {
      provide(key, value);
    },
    inject: (fallback?: T) => {
      const injectedValue = inject(key, fallback) as T;

      return injectedValue;
    },
  };
};
